import React, { useContext, useEffect } from "react";
import { useMutation } from "@apollo/client";
import { BlockStack } from "@shopify/polaris";

// import helper components
import { Spinner } from "lib/components";

// import helper
import baseHelper from "lib/helpers/base";

// import context
import { PrivateContext } from "lib/context";

// import constant
import constant from "lib/constant/constant";

// import hoc
import { withErrorBoundary } from "lib/hoc";

import { errorHelper } from "lib/helpers";

// import gql
import { CONNECT_PAYPAL_VENDOR } from "app/setup/apollo/mutations";
import { useLocation, useNavigate } from "react-router-dom";

const PaypalCallback = () => {
  const [connectToPaypal, { loading }] = useMutation(CONNECT_PAYPAL_VENDOR);
  const { gql } = constant;
  const { currentUser, currentUserRefetch = () => {}, isLoading, cms } = useContext(PrivateContext);
  const { _id: id } = currentUser;
  const location = useLocation();
  const navigate = useNavigate();
  const { code, state } = baseHelper.getQueryParams(location.search);

  const connectPaypal = async () => {
    try {
      const response = await connectToPaypal({ variables: { input: { code } } });

      const responseData = baseHelper.getResponseData(response.data, gql.CONNECT_PAYPAL_VENDOR);
      const responseError = baseHelper.getResponseError(response.data, gql.CONNECT_PAYPAL_VENDOR);

      if (responseError) {
        navigate("/payment-connect", { isPaypalConnected: false, message: responseError });
      }

      if (responseData) {
        currentUserRefetch();
        navigate("/payment-connect", {
          isPaypalConnected: true,
        });
      }
    } catch (exception) {
      navigate("/payment-connect", { isPaypalConnected: false, message: errorHelper.parse(exception) });
    }
  };

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (code) {
      connectPaypal();
    } else {
      navigate("/payment-connect");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, code, navigate]);

  if (isLoading || loading) {
    return <Spinner fontSize={42} />;
  }

  if (id !== state) {
    return <BlockStack gap="2">{cms("common.message.error.notFound")}</BlockStack>;
  }

  return null;
};

export default withErrorBoundary(PaypalCallback);
